import React from 'react'

const EditFoodCoupon = () => {
    return (
        <div>EditFoodCoupon</div>
    )
}

export default EditFoodCoupon